<!-- Page Header Start-->
<div class="page-header" [class.close_icon]="navServices.collapseSidebar">
  <div class="header-wrapper row m-0">
    <app-search></app-search>
    <div class="header-logo-wrapper">
      <div class="logo-wrapper">
        <a routerLink={{path}}>
          <img class="img-fluid for-light" src="assets/images/logo/logo.png" alt="">
          <img class="img-fluid for-dark" src="assets/images/logo/logo_dark.png" alt="">
        </a>
      </div>
      <div class="toggle-sidebar" (click)="sidebarToggle()">
        <app-feather-icons [icon]="'grid'" class="status_toggle middle"></app-feather-icons>
      </div>
    </div>
    <!-- <div class="left-header col horizontal-wrapper pl-0"> -->
      <!-- <app-mega-menu></app-mega-menu> -->
    <!-- </div> -->
    
    <!-- MC CATFER-92 -->
    <div class="col d-none d-md-block nombre-cliente-header">
      <span *ngIf="!admin">Bienvenido/a, <b>{{ nombreCliente }}</b></span>
    </div>

    <div class="nav-right col pull-right right-header p-0">
      <ul class="nav-menus mr-0">
        <!-- <li *ngIf="update && !admin" class="py-0">
          <ng-container >
            <button
              pButton
              pRipple
              type="button"
              icon="pi pi-refresh"
              class="p-button-rounded p-button-success bounce_btn"
              (click)="reloadPage()"
              pTooltip="Actualización disponible"
            ></button>
          </ng-container>
        </li> -->
        <li class="language-nav" (click)="languageToggle()">
          <app-languages></app-languages>
        </li>
        <ng-container *ngIf="!admin">
          <li>
            <span class="header-search" (click)="searchToggle()">
              <app-feather-icons [icon]="'search'"></app-feather-icons>
            </span>
          </li>
          <li class="onhover-dropdown">
            <app-notification></app-notification>
          </li> 
        </ng-container>
        
        <!-- <li class="onhover-dropdown">
          <app-bookmark></app-bookmark>
        </li> -->
        <!-- <li>
          <div class="mode" (click)="layoutToggle()">
            <i class="fa fa-moon-o" *ngIf="!dark"></i>
            <i class="fa fa-lightbulb-o" *ngIf="dark"></i>
          </div>
        </li> -->
        <ng-container *ngIf="!admin && (rol == 1 || rol == 2)">
          <li class="cart-nav onhover-dropdown">
            <app-cart></app-cart>
          </li>
        </ng-container>
        <!-- <li class="onhover-dropdown">
          <app-message-box></app-message-box>
        </li> -->
        <li class="maximize">
          <a class="text-dark" href="javascript:void(0)" (click)="toggleFullScreen()">
            <app-feather-icons [icon]="'maximize'"></app-feather-icons>
          </a>
        </li>
        <li class="profile-nav onhover-dropdown p-0">
           <app-my-account [nombreCliente]="nombreCliente"></app-my-account>
        </li>
      </ul>
    </div>
  </div>
</div>
<!-- Page Header Ends -->